import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { entryRestrictionsBackend } from './entry-restrictions.backend';
import { entryRestrictionsReducer } from './entry-restrictions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('entryRestrictions', entryRestrictionsReducer),
    BackendModule.forFeature('entryRestrictions', entryRestrictionsBackend),
  ],
})
export class DatastoreEntryRestrictionsModule {}
